module.exports = __webpack_public_path__ + "static/img/merchant_case_5.9f70d2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_case_5.png
// module id = oXkt
// module chunks = 8